import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const telegram: Platform = {
  id: 'telegram',
  name: 'Telegram',
  iconIndex: PlatformRegistry.telegram.index,
  color: PlatformRegistry.telegram.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://t.me/share/url', {
      url: content.url,
      text: content.title,
    });
  },
};

